module.exports = __webpack_public_path__ + "img/auth.92b6416b.jpg";